var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eu-display_flex eu-justify_space-between_lg" },
    [
      _c("div", { staticClass: "eu-mb_5 eu-mr_5" }, [
        _c(
          "p",
          { staticClass: "emd-text _color_subtle _type_caption eu-mb_1" },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("charge.detail.payment-method.card.expires")) +
                " "
            ),
          ]
        ),
        _c("p", [
          _vm._v(
            _vm._s(_vm.computedExpMonth) + "/" + _vm._s(_vm.computedExpYear)
          ),
        ]),
      ]),
      _c("div", { staticClass: "eu-mb_5" }, [
        _c(
          "p",
          { staticClass: "emd-text _color_subtle _type_caption eu-mb_1" },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("charge.detail.payment-method.card.installments")
                ) +
                " "
            ),
          ]
        ),
        _c("p", [_vm._v(_vm._s(_vm.installments || "-"))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }